import { createReducer } from '@reduxjs/toolkit';
import { setPageProperties } from '@yme/common/redux/common/action';
import { setSocialLinks, setFooterLabels } from '../../Footer/redux/actions';
const initialState = {
    country: '',
    language: '',
    socialLinks: [],
    footerLabels: {},
    labels: {},
};
export const reducer = createReducer(initialState, (builder) => {
    builder
        .addCase(setPageProperties, (state, action) => ({
        ...state,
        country: action.payload.currentCountryRoot,
        language: action.payload.currentLanguageRoot,
    }))
        .addCase(setSocialLinks, (state, action) => ({
        ...state,
        socialLinks: action.payload,
    }))
        .addCase(setFooterLabels, (state, action) => ({
        ...state,
        footerLabels: action.payload,
    }));
});
